<template>
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col cols="12" md="6" class="mb-md-0 mb-2">
          <label>{{ $t('Owner') }}</label>
          <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="ownerFilter"
              :options="ownersOptions"
              class="w-100"
              :reduce="val => val.id"
              label="name"
              @input="(val) => $emit('update:ownerFilter', val)"
          />
        </b-col>

        <b-col cols="12" md="6" class="mb-md-0 mb-2">
          <label>{{$t('Contract')}}</label>
          <v-select
              :close-on-select="false"
              multiple
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="contractFilter"
              :options="contractOptions"
              class="w-100"
              :reduce="val => val.id"
              label="name"
              @input="(val) => $emit('update:contractFilter', val)"
          />
        </b-col>

      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: { BRow, BCol, BCard, BCardHeader, BCardBody, vSelect, },
  props:['contractFilter','contractOptions',
    'ownersOptions','ownerFilter'],

}
</script>

